import { render, staticRenderFns } from "./deliveryRule.vue?vue&type=template&id=5178e30e&scoped=true"
import script from "./deliveryRule.vue?vue&type=script&lang=js"
export * from "./deliveryRule.vue?vue&type=script&lang=js"
import style0 from "./deliveryRule.vue?vue&type=style&index=0&id=5178e30e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5178e30e",
  null
  
)

export default component.exports